import ShopArticleResourcePagingResultModel from '../../generated/types/model/resource/ShopArticleResourcePagingResultModel';

export default class ShopArticleResourcePagingResultViewModel extends ShopArticleResourcePagingResultModel {
  // For instructions on how to use ViewModels visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
